import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';

// Services
import { LoggerService } from '../../services/logger/logger.service';
import { OfflineService } from '../../services/offline/offline.service';
import { WsErrorService } from '../../services/ws-error/ws-error.service';

export const CheckOfflineFilesGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const logger = inject(LoggerService);
  const offline = inject(OfflineService);
  const wsError = inject(WsErrorService);

  return new Observable((observer) => {
    if (!offline || !offline.offlineFile?.INFRAULTRA.buffer || !offline.offlineFile?.NORMAL.buffer) {
      logger.consoleError('CheckOfflineFilesGuard', 'canActivate', 'setWebServiceError');
      wsError.setWebServiceError('COMMON.DOWNLOADING_MP3', true, true);
    }

    offline
      .obtainMp3s()
      .then(() => observer.next(true))
      .catch(() => {
        logger.consoleError('CheckOfflineFilesGuard', 'canActivate', 'setWebServiceError');
        wsError.setWebServiceError('COMMON.NO_OFFLINE_MP3_FOUND');
      });
  });
};
